import React from "react";
import { Opportunity, UserProfile } from "../../types";
import { RequirementsTab, PlanSubTab } from "./RequirementsTab";

export interface PlanTabProps {
  opportunity: Opportunity;
  user: UserProfile | null;
  initialSubTab?: PlanSubTab;
}

/**
 * PlanTab - Stage 3: Proposal Response Plan
 * Houses the response schedule & milestones timeline, RFP addenda log,
 * requirements matrix, bid section ownership & workload allocation,
 * required forms roster, and format & submission rules.
 */
export const PlanTab: React.FC<PlanTabProps> = ({
  opportunity,
  user,
  initialSubTab = "schedule",
}) => {
  return <RequirementsTab opportunity={opportunity} user={user} initialSubTab={initialSubTab} />;
};
